var render = function render(){var _vm=this,_c=_vm._self._c;return _c('WujieVue',{staticClass:"angular-container",attrs:{"name":"angular12","url":_vm.url,"attrs":_vm.attrs,"sync":true}})
}
var staticRenderFns = []

export { render, staticRenderFns }